<script>
import isEmpty from 'lodash.isempty'
import ImageWrapper from '@/components/atoms/ImageWrapper'
import DeliveryInfo from '@/components/atoms/restaurant/DeliveryInfo'
import GeneralInfo from '@/components/atoms/restaurant/GeneralInfo'

// One profile ("menu") of a store on the brand page: thumbnail, name, fee line and the
// delivery-time chip. Same link and no-address behaviour as RestaurantCard, but as two
// template branches: Vue 2.6 does not support modifiers on the object form of v-on, so
// RestaurantCard's `v-on.native="{...}"` never attaches its click handler on the link.
// Brand-page only; styles live in src/assets/style/page/_brand.scss (`.menu-row*`).
export default {
    name: 'MenuRow',

    components: { ImageWrapper, DeliveryInfo, GeneralInfo },

    props: {
        model: {
            type: Object,
            required: true,
        },
        delay: Boolean,
    },

    computed: {
        hasAddress() {
            return !isEmpty(this.$store.getters['order/address'])
        },
        route() {
            return this.model.slug
                ? {
                      name: 'restaurant',
                      params: { slug: this.model.slug },
                      query: { ...this.$route.query, card: true },
                  }
                : undefined
        },
        isLink() {
            return !!this.route && this.hasAddress
        },
    },

    methods: {
        async onClick(e) {
            // This guard alone cannot stop a router-link navigation (vue-router's own
            // click handler runs before this `.native` listener); the real guards are the
            // `pointer-events: none` + `tabindex="-1"` on the delayed row.
            if (this.delay) {
                e.preventDefault()
                return
            }
            if (!this.hasAddress) {
                e.preventDefault()
                if (this.$user.isLoggedIn) this.$location.select.open()
                else this.$location.enter.open()
                return
            }
            if (this.route) await this.$restaurant.fetchRestaurant(this.model.slug)
        },
    },
}
</script>

<template lang="pug">
router-link.menu-row(v-if="isLink" :to="route" :class="{ 'menu-row-delayed': delay }" :tabindex="delay ? -1 : null" :aria-disabled="delay ? 'true' : null" @click.native="onClick")
    image-wrapper.menu-row-image(:src="model.image" background skeleton-loader :tag="$t('tags.restaurant_card', { name: model.name })")
    .menu-row-body
        span.menu-row-name {{ model.name }}
        general-info.menu-row-info(v-if="hasAddress" :model="model" sm)
        delivery-info(:model="model")
button.menu-row(v-else type="button" :class="{ 'menu-row-delayed': delay }" :disabled="delay" @click="onClick")
    image-wrapper.menu-row-image(:src="model.image" background skeleton-loader :tag="$t('tags.restaurant_card', { name: model.name })")
    .menu-row-body
        span.menu-row-name {{ model.name }}
        general-info.menu-row-info(v-if="hasAddress" :model="model" sm)
        delivery-info(:model="model")
</template>
